import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { TabContainer } from "./Social.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { useState } from "react";
import General from "../../stores/GeneralStore";
import { Document } from "../Temporary Components/SocialCaseModal.styled";
import { observer } from "mobx-react";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import trashIcon from "../../assets/trash.svg";

const Documents = observer(
  ({ onSubmit,submitLoader }: { onSubmit: (files: any) => Promise<void>,submitLoader:Boolean }) => {
    const [uploadedFiles, setUploadedFiles] = useState<{ [key: string]: File }>(
      {}
    );
    const [validationErrors, setValidationErrors] = useState<{
      [key: string]: boolean;
    }>({});
    const mandatoryDocumentsInitialState = [
      { key: "passportFile", label: General?.codeLabels["cm_attach_passport"]?.label ?? "Passport Copy" },
      { key: "emiratesIdFile", label: General?.codeLabels["cm_uni"]?.label ?? "Emirates ID" },
      { key: "familyBookIdFile", label: General?.codeLabels["cm_family_book"]?.label ?? "Family Book" },
      { key: "salaryOrRetirementCertificateFile", label: General?.codeLabels["cm_attach_salary"]?.label ?? "Salary or Retirement Certificate" },
      { key: "titleDeedFile", label: General?.codeLabels["cm_attach_title"]?.label ?? "Title Deed" },
      { key: "bankStatementFile", label: General?.codeLabels["cm_bank_statement"]?.label ?? "Bank Statement (last 3 months)" },
      { key: "propertyCertificateFromLandDeptFile", label: General?.codeLabels["cm_lan_dep"]?.label ?? "Property Certificate from Land Dept." },
      { key: "propertyCertificateFromAjmanMunicipalityFile", label: General?.codeLabels["cm_lan_cer"]?.label ?? "Property Certificate from Ajman Municipality" },
  ];

  const [mandatoryDocuments, setMandatoryDocuments] = useState(mandatoryDocumentsInitialState);
    const addMoreDocuments = () => {
      const newDocument = { key: `newDocument${mandatoryDocuments.length}`, label:General?.codeLabels['cm_application_documents']?.label };
      setMandatoryDocuments([...mandatoryDocuments, newDocument]);
  };

  const handleRemoveField = (key: string) => {
    console.log(key);
    const documents = mandatoryDocuments.filter(d => d.key != key);
    setMandatoryDocuments(documents);

    setValidationErrors((prevErrors) => {
      const { [key]: _, ...rest } = prevErrors;
      return rest;
    });

  }

    const handleFileEvent = (
      e: React.ChangeEvent<HTMLInputElement>,
      inputName: string,
      label: string,
    ) => {
      const chosenFiles = e.target.files;
    
      if (chosenFiles && chosenFiles.length > 0) {
        const renamedFile = new File(
          [chosenFiles[0]],
          `${label}-${chosenFiles[0].name}`,
          { type: chosenFiles[0].type }
        );
    
        setUploadedFiles((prevFiles) => ({
          ...prevFiles,
          [inputName]: renamedFile,
        }));
    
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [inputName]: false,
        }));
      }
    };
    
    const handleSubmit = () => {
      const missingMandatoryDocuments = mandatoryDocuments.filter(
        (doc) => !uploadedFiles[doc.key]
      );

      if (missingMandatoryDocuments.length > 0) {
        const newErrors: { [key: string]: boolean } = {};
        missingMandatoryDocuments.forEach((doc) => {
          newErrors[doc.key] = true;
        });
        setValidationErrors(newErrors);
        return;
      }

      onSubmit(uploadedFiles);
    };


    return (
      <>
        <TabContainer style={{flexDirection:'column',
        display:General?.isLargeScreen?"":'flex'}}>
          <p
            style={{
              gridColumn: "1 / span 2",
              paddingTop: "10px",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: `${General.accessibility.fontSize}rem`,
              lineHeight: "20px",
              color:General?.contrast?.contrastColor?General?.contrast?.contrastColor:General?.ColorAss
            }}
          >
            {General?.codeLabels["cm_pdc_all"]?.label?General?.codeLabels["cm_pdc_all"]?.label:"Upload all mandatory documents and use optional documents feature for any supporting documents"}
          </p>
          {mandatoryDocuments.map((doc) => (
            <div key={doc.key}>
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <div style={{
                  width: doc.label == General?.codeLabels['cm_application_documents']?.label? "90%" : "100%",  
                }}>
                    <Document
                    exists={uploadedFiles[doc.key] !== undefined}
                    mainText={doc.label}
                    subText={General?.codeLabels["cm_mandatory_document"]?.label?General?.codeLabels["cm_mandatory_document"]?.label:"Mandatory Document"}
                    onChange={(e) => handleFileEvent(e, doc.key,doc?.label)}
                    inputName={doc.key}
                    label={doc?.label}
                  />
                  {validationErrors[doc.key] && (
                    <p
                      style={{
                        color: "red",
                        margin: "4px 0 0 0",
                        fontWeight: "bold",
                      }}
                    >
                      {General?.codeLabels["cm_socialcasenofileerr"]?.label?General?.codeLabels["cm_socialcasenofileerr"]?.label:'Please upload file for'} {doc.label}
                    </p>
                  )}
                </div>
                <div>
                  {doc.label == General?.codeLabels['cm_application_documents']?.label &&
                      <button type="button" style={{cursor: 'pointer', background: 'none', border: 0 }} onClick={() => handleRemoveField(doc.key)} >
                          <img src={trashIcon} alt="Remove Optional Attachment"/>
                      </button>
                  }
                </div>
              </div>
            </div>
          ))}
         <Label>
         <div
            style={{
              height: "43px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <ButtonSecondary
              style={{
                alignSelf: "end",
                width:General?.isLargeScreen? "205px":"98%",
                height: "36px",
                background: General?.contrast?.contrastBackground?General?.contrast?.contrastBackground:"#FFFFFF",
                border: General?.contrast?.contrastColor?`1px solid ${General?.contrast?.contrastColor}`:" 1px solid #101E8E",
                fontWeight: "900",
                padding: "10px 0",
                fontFamily: "Segoe UI",
                fontStyle: "normal",
                fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                lineHeight: "16px",
                color:General?.contrast?.contrastColor?General?.contrast?.contrastColor:General?.ColorAss
              }}
              onClick={addMoreDocuments}
            >
              {General?.codeLabels["cm_add_more"]?.label?General?.codeLabels["cm_add_more"]?.label:'ADD MORE DOCUMENTS'}
            </ButtonSecondary>
          </div> 
         </Label>
          <hr
            style={{
              gridColumn: "1 / span 2",
              width: "100%",
              backgroundColor: "#101E8E",
              mixBlendMode: "normal",
              opacity: "0.2",
            }}
          />
          <ButtonSecondary
            style={{
              width:General?.isLargeScreen? "168px":"98%",
              height: "50px",
              background: General?.contrast?.contrastColor?General?.contrast?.contrastColor:"#101e8e",
              color: General?.contrast?.contrastBackground?General?.contrast?.contrastBackground:"#fff",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: `${General.accessibility.fontSize}rem`,
              lineHeight: "16px",
            }}
            onClick={handleSubmit}
          >
            {submitLoader?<Spinner width="30px" height="30px" />: General?.codeLabels["cm_submit"]?.label !== undefined
              ? General?.codeLabels["cm_submit"]?.label
              : "SUBMIT"}
          </ButtonSecondary>
        </TabContainer>
      </>
    );
  }
);

export default Documents;
